import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Promo } from '../../models/promo';

export const GET_PROMOS = '[Promos] Get promos';
export const GET_PROMOS_SUCCESS = '[Promos] Get promos success';
export const GET_PROMOS_FAIL = '[Promos] Get promos fail';
export const SELECT_PROMO = '[Promos] Select current promo';

export const GET_STATS = '[Promos] Get stats';
export const GET_STATS_SUCCESS = '[Promos] Get stats success';
export const GET_STATS_FAIL = '[Promos] Get stats fail';

export const UPDATE_STATS = '[Promos] Update stats';

export const GetPromos = createAction(GET_PROMOS);
export const GetPromosSuccess = createAction(GET_PROMOS_SUCCESS, (promos: Promo[]) => ({ promos }));
export const GetPromosFail = createAction(GET_PROMOS_FAIL, (err: HttpErrorResponse) => ({ err }));
export const SelectPromo = createAction(SELECT_PROMO, (name: string) => ({ name }));

export const GetStats = createAction(GET_STATS, props<{ promo: string; userId?: number; promoId?: number }>());
export const GetStatsSuccess = createAction(GET_STATS_SUCCESS, (stats: any) => ({ stats }));
export const GetStatsFail = createAction(GET_STATS_FAIL, (err: HttpErrorResponse) => ({ err }));

export const UpdateStats = createAction(UPDATE_STATS, (stats: any) => ({ stats }));
